export function ViewIndivSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="1000"
      height="1000"
      viewBox="0 0 1000 1000"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.5}
    >
      <rect x="0" y="0" width="100%" height="100%" fill="none" />
      <g transform="matrix(1.3871 0 0 1.3871 412.1898 496.4058)" id="400683">
        <path
          transform=" translate(-288.05, -256)"
          d="M 288 32 c -80.8 0 -145.5 36.8 -192.6 80.6 C 48.6 156 17.3 208 2.5 243.7 c -3.3 7.9 -3.3 16.7 0 24.6 C 17.3 304 48.6 356 95.4 399.4 C 142.5 443.2 207.2 480 288 480 s 145.5 -36.8 192.6 -80.6 c 46.8 -43.5 78.1 -95.4 93 -131.1 c 3.3 -7.9 3.3 -16.7 0 -24.6 c -14.9 -35.7 -46.2 -87.7 -93 -131.1 C 433.5 68.8 368.8 32 288 32 z M 144 256 a 144 144 0 1 1 288 0 a 144 144 0 1 1 -288 0 z m 144 -64 c 0 35.3 -28.7 64 -64 64 c -7.1 0 -13.9 -1.2 -20.3 -3.3 c -5.5 -1.8 -11.9 1.6 -11.7 7.4 c 0.3 6.9 1.3 13.8 3.2 20.7 c 13.7 51.2 66.4 81.6 117.6 67.9 s 81.6 -66.4 67.9 -117.6 c -11.1 -41.5 -47.8 -69.4 -88.6 -71.1 c -5.8 -0.2 -9.2 6.1 -7.4 11.7 c 2.1 6.4 3.3 13.2 3.3 20.3 z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="matrix(14.2306 0 0 14.2306 873.4847 664.883)" id="469697">
        <path
          transform=" translate(-8, -10.5)"
          d="M 14 7 L 13 7 L 13 5 C 13 2.2 10.8 0 8 0 C 5.2 0 3 2.2 3 5 L 3 7 L 2 7 C 0.9 7 0 7.9 0 9 L 0 19 C 0 20.1 0.9 21 2 21 L 14 21 C 15.1 21 16 20.1 16 19 L 16 9 C 16 7.9 15.1 7 14 7 L 14 7 Z M 8 16 C 6.9 16 6 15.1 6 14 C 6 12.9 6.9 12 8 12 C 9.1 12 10 12.9 10 14 C 10 15.1 9.1 16 8 16 L 8 16 Z M 11.1 7 L 4.9 7 L 4.9 5 C 4.9 3.3 6.3 1.9 8 1.9 C 9.7 1.9 11.1 3.3 11.1 5 L 11.1 7 L 11.1 7 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
